import React from "react";
import { social } from "../data/socialData";

export default function Socials(){

    return(
        <div className="socials">
                <ul>
                    {social.map((item, index) => (
                         <li key={index} className={item.name}>
                             <a href={item.link} target="_blank" rel="noopener noreferrer">
                                <div className={item.name}></div>
                            </a>
                         </li>
                         
                    ))}
                   
                </ul>
            </div>
    )
    
}